import { Form, Select, SelectProps } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { FormItem } from '../../components/form-item'
import { clarificationDepth, ClarificationDepth } from '../input/store-input'

type ClarificationDepthFieldProps = SelectProps<ClarificationDepth>

export function ClarificationDepthField(props: ClarificationDepthFieldProps) {
    const { t } = useTranslation()

    const form = Form.useFormInstance()
    const depth = Form.useWatch(['data', 'clarificationDepth'], { form, preserve: true }) ?? 'once'

    return (
        <FormItem
            name={['data', 'clarificationDepth']}
            label={t('Follow-up questions')}
            extra={t(`clarificationDepth.${depth}.help`)}
        >
            <Select<ClarificationDepth>
                options={clarificationDepth.options.map((value) => ({
                    value,
                    label: t(`clarificationDepth.${value}`),
                }))}
                {...props}
            />
        </FormItem>
    )
}
